import queryString from "query-string";
import { Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../hooks";
import { PageHeader, Pagination } from "../../components";
import List from "./unverified list components/List";
import { CancelButton } from "../css components/Button";

export default function UnverifiedBrandList() {
  const axios = useAxios();
  const { state } = useLocation();
  const navigate = useNavigate();

  const platformID = queryString.parse(window.location.search).platformID;
  const agencyID = queryString.parse(window.location.search).agencyID;

  const [brands, setBrands] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [categorize, setCategorize] = useState(platformID);
  const [filterByAgency, setFilterByAgency] = useState(agencyID);
  const [page, setPage] = useState({
    page: 1,
    totalCount: 0,
    lastPage: false,
  });

  useEffect(() => {
    setLoading(true);
    axios({
      url:
        "/getAllBrands?page=" +
        page.page +
        "&limit=10" +
        (categorize !== "" ? "&platform_id=" + categorize : "") +
        (filterByAgency !== "" ? "&agency_id=" + filterByAgency : "") +
        (sortBy !== "" ? "&is_brand_verified=" + sortBy : "") +
        (Boolean(searchKey) ? "&search=" + encodeURIComponent(searchKey) : ""),
      method: "GET",
      disableRedirect: false,
    }).then((response) => {
      if (response.status) {
        setBrands(response.data.parsedBrands);

        setPage((prev) => ({
          ...prev,
          totalCount: response.data?.totalCount,
          lastPage: response.data.parsedBrands.length < 10,
        }));
      } else {
        setBrands([]);

        setPage((prev) => ({
          ...prev,
          totalCount: response.data?.totalCount,
          lastPage: response.data.parsedBrands.length < 10,
        }));
      }
      setLoading(false);
    });
  }, [axios, page.page, searchKey, filterByAgency, categorize, sortBy]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev.page + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageName={"Brands"}
            pageHeader={"List of brands"}
            buttons={[
              state?.component === "platform" && (
                <CancelButton variant="outlined" onClick={() => navigate(-1)}>
                  Back
                </CancelButton>
              ),
            ]}
          />
        </Grid>
      </Grid>

      <List
        platformID={platformID}
        setFilterByAgency={setFilterByAgency}
        filterByAgency={filterByAgency}
        sortBy={sortBy}
        setSortBy={setSortBy}
        setPage={setPage}
        setSearchKey={setSearchKey}
        loading={loading}
        brands={brands}
        categorize={categorize}
        setCategorize={setCategorize}
      />

      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
